import { styled } from '@/styled-system/jsx';

export const StyledPpcLinkWrapper = styled('div', {
  base: {
    '& a:hover': {
      textDecoration: 'underline',
    },
  },
});

export const StyledPpcLinkTarget = styled('span', {
  base: {
    display: 'inline-block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    verticalAlign: 'top',
    xl: {
      maxWidth: '430px',
    },
  },
});

export const StyledPpcLinkIcon = styled('img', {
  base: {
    marginLeft: '5px',
    paddingBottom: '2px',
    width: '14px',
  },
});
